import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { BulkEstimateContactType } from '@rivethealth/data/contact';
import { BulkChip } from '@rivethealth/data/ui-search-item';

@Component({
  selector: 'bulk-chip',
  styleUrls: ['./bulk-chip.component.scss'],
  templateUrl: './bulk-chip.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulkChipComponent {
  @Input() chip: BulkChip;
  @Input() chipType: BulkEstimateContactType;

  @Output() remove = new EventEmitter();
  @Output() openPatientEdit = new EventEmitter();
  @Output() openSelectContactField = new EventEmitter();

  fixInvalidAction() {
    if (this.chip.editPatient) {
      this.openPatientEdit.emit();
    } else if (this.chip.selectContactField) {
      this.openSelectContactField.emit();
    }
  }

  BulkEstimateContactType = BulkEstimateContactType;
}
